import type { ReactNode } from 'react';
import { useNavigate } from '@ksyos/router';
import { IconColor } from '../../atoms/icon/Icon';
import { IconLink } from '../iconLink/IconLink';

interface IGoBackButtonProps {
    backUrl?: string;
    children: ReactNode;
    color?: IconColor;
    onClick?: () => void;
    position?: 'left' | 'right';
}

export function GoBackButton(props: IGoBackButtonProps) {
    const navigate = useNavigate();

    return (
        <IconLink
            color={IconColor.black}
            icon="caret-left"
            linkColor="black"
            noTextDecoration
            onClick={() => (props.backUrl ? navigate(props.backUrl) : navigate(-1))}
            position="left"
            to={props.backUrl || '/'}
        >
            {props.children}
        </IconLink>
    );
}
